import { useCallback, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { apiTokenRequest } from '../authConfig';

/**
 * Returns a referentially stable `getToken()` that resolves the API access token silently.
 * Stability matters: callers put it in effect/useCallback deps, and `accounts` can be a fresh
 * array on every MSAL render, which would otherwise re-trigger their fetch effects in a loop.
 */
export function useApiToken() {
    const { instance, accounts } = useMsal();
    const msalRef = useRef({ instance, accounts });
    msalRef.current = { instance, accounts };
    return useCallback(async () => {
        const { instance: inst, accounts: accts } = msalRef.current;
        const res = await inst.acquireTokenSilent({ ...apiTokenRequest, account: accts[0] });
        return res.accessToken;
    }, []);
}
